import t from"@tailwindcss/forms";import i from"../tailwind.config.js";const s={plugins:[t],theme:i.theme,variants:i.variants};export{s as default};
